import { transaction } from 'api/payments/fixtures/transaction.fixture';
import { transactions } from 'api/payments/fixtures/transactions.fixture';
import { rest } from 'msw';
import { makeListResults } from 'test-util/api/response';
import { getEnv } from 'util/getEnv';
import { getAccountAccounts } from './fixtures/account.fixture';
import { accounts } from './fixtures/accounts.fixture';
import { disputes } from './fixtures/disputes';
import { accountLink } from './fixtures/create-account-link.fixture';
import { getFileLink } from './fixtures/get-file-link.fixture';
import { paymentsReportsData } from './fixtures/payments-reports-data.fixture';

export const listAccountsMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-payments/paymentaccounts`,
    fn,
  );

export const getAccountMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/paymentaccounts/:paymentAccountId`,
    fn,
  );

export const createAccountMock = fn =>
  rest.post(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-payments/paymentaccounts`,
    fn,
  );

export const updateAccountMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/paymentaccounts/:paymentAccountId`,
    fn,
  );

export const deleteAccountMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/paymentaccounts/:paymentAccountId`,
    fn,
  );

export const listTransactionsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/payments/transactions`,
    fn,
  );

export const getTransactionMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/payments/transactions/:transactionId`,
    fn,
  );

export const createAccountLinkMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/paymentaccounts/:paymentAccountId/accountlink`,
    fn,
  );

export const getPaymentsReportsMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-payments/payments/reports`,
    fn,
  );

export const listDisputesMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-payments/disputes`,
    fn,
  );

export const acceptDisputeMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/disputes/:disputeId/accept`,
    fn,
  );

export const refundPaymentMock = fn =>
  rest.post(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/payments/transactions/refund`,
    fn,
  );

export const uploadToStripeMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/disputes/:disputeId/upload`,
    fn,
  );

export const challengeDisputeMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/disputes/:disputeId/submit`,
    fn,
  );

export const getFileLinkMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/disputes/:disputeId/file/:fileId/retrieve`,
    fn,
  );

export const getDisputeMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-payments/disputes/:disputeId`,
    fn,
  );

export const handlers = () => [
  listAccountsMock((_req, res, ctx) => {
    return res(ctx.json(accounts));
  }),

  getAccountMock((req, res, ctx) => {
    return res(ctx.json(getAccountAccounts[req.params.paymentAccountId]));
  }),

  createAccountMock((req, res, ctx) => {
    return res(
      ctx.json({
        ...getAccountAccounts[req.params.paymentAccountId],
        balance: undefined,
        stripeAccount: undefined,
      }),
    );
  }),

  updateAccountMock((req, res, ctx) => {
    return res(
      ctx.json({
        ...getAccountAccounts[req.params.paymentAccountId],
        balance: undefined,
        stripeAccount: undefined,
      }),
    );
  }),

  deleteAccountMock((req, res, ctx) => {
    return res(ctx.json());
  }),

  createAccountLinkMock((_req, res, ctx) => {
    return res(ctx.json(accountLink));
  }),

  getPaymentsReportsMock((_req, res, ctx) => {
    return res(ctx.json(paymentsReportsData));
  }),

  listTransactionsMock((req, res, ctx) => {
    return res(
      ctx.json(makeListResults(transactions.content, req.url.searchParams)),
    );
  }),

  getTransactionMock((req, res, ctx) => {
    return res(
      ctx.json(transaction[req.params.transactionId] ?? transaction.order),
    );
  }),

  refundPaymentMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  listDisputesMock((req, res, ctx) => {
    const chargebacksList = Object.values(disputes);

    return res(
      ctx.json(
        makeListResults(chargebacksList, req.url.searchParams, {
          listName: 'content',
        }),
      ),
    );
  }),

  acceptDisputeMock((_req, res, ctx) => {
    return res(ctx.status(204));
  }),

  uploadToStripeMock((_req, res, ctx) => {
    return res(
      ctx.json({
        fileId: 'test_file_id',
        fileUrl:
          'https://s3.amazonaws.com/incentdev/d2776d2a-33ae-4f3b-8091-34cad2e69fdc/s/Basic%20Item_4b6e2a810851478ba9fcc0964220c9ba.png',
      }),
    );
  }),

  challengeDisputeMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getFileLinkMock((_req, res, ctx) => {
    return res(ctx.json(getFileLink));
  }),

  getDisputeMock((req, res, ctx) => {
    return res(ctx.json(disputes[req.params.disputeId]));
  }),
];
